import { loadStripe } from '@stripe/stripe-js'

// CON-9030: Stripe.js is preloaded via <link rel="preload"> in fullScreenApp.html.twig, so the
// network fetch starts in <head>. Load immediately — this is the consumer checkout page and Stripe
// is a critical dependency; the session's client secret is fetched in parallel, and the provider
// will not mount until both are in hand.
//
// CON-9505: lives in its own module because CheckoutElementsProvider exposes no useStripe(), so the
// page imports the same promise the provider was handed rather than a second Stripe instance.
// The beta is what lets Stripe call onRequiresApproval on a session created for manual approval (CON-9591).
const stripePromise = loadStripe(window.React.stripeKey, {
    betas: ['custom_checkout_manual_approval_1'],
})

export default stripePromise
